import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ProductAttributesApi - axios parameter creator
 * @export
 */
const ProductAttributesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByProduct: async (pid, options = {}) => {
            const localVarPath = `/v1/ProductAttributes/DeleteByProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (pid !== undefined) {
                localVarQueryParameter['pid'] = pid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (pid, options = {}) => {
            const localVarPath = `/v1/ProductAttributes/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (pid !== undefined) {
                localVarQueryParameter['pid'] = pid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllByProduct: async (pid, options = {}) => {
            const localVarPath = `/v1/ProductAttributes/GetAllByProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (pid !== undefined) {
                localVarQueryParameter['pid'] = pid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [cid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCategory: async (cid, options = {}) => {
            const localVarPath = `/v1/ProductAttributes/GetByCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (cid !== undefined) {
                localVarQueryParameter['cid'] = cid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByProduct: async (pid, options = {}) => {
            const localVarPath = `/v1/ProductAttributes/GetByProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (pid !== undefined) {
                localVarQueryParameter['pid'] = pid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductAttributeToken} [ProductAttributeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (ProductAttributeToken, options = {}) => {
            const localVarPath = `/v1/ProductAttributes/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ProductAttributeToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/ProductAttributes/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductAttributeToken} [ProductAttributeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (ProductAttributeToken, options = {}) => {
            const localVarPath = `/v1/ProductAttributes/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ProductAttributeToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProductAttributesApi - functional programming interface
 * @export
 */
const ProductAttributesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductAttributesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteByProduct(pid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteByProduct(pid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductAttributesApi.deleteByProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(pid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(pid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductAttributesApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllByProduct(pid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllByProduct(pid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductAttributesApi.getAllByProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [cid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByCategory(cid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByCategory(cid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductAttributesApi.getByCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByProduct(pid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByProduct(pid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductAttributesApi.getByProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductAttributeToken} [ProductAttributeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(ProductAttributeToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(ProductAttributeToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductAttributesApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductAttributesApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductAttributeToken} [ProductAttributeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(ProductAttributeToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(ProductAttributeToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductAttributesApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ProductAttributesApi - factory interface
 * @export
 */
const ProductAttributesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductAttributesApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByProduct(pid, options) {
            return localVarFp.deleteByProduct(pid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(pid, options) {
            return localVarFp.getAll(pid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllByProduct(pid, options) {
            return localVarFp.getAllByProduct(pid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [cid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCategory(cid, options) {
            return localVarFp.getByCategory(cid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByProduct(pid, options) {
            return localVarFp.getByProduct(pid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductAttributeToken} [ProductAttributeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(ProductAttributeToken, options) {
            return localVarFp.insert(ProductAttributeToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductAttributeToken} [ProductAttributeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(ProductAttributeToken, options) {
            return localVarFp.update(ProductAttributeToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductAttributesApi - object-oriented interface
 * @export
 * @class ProductAttributesApi
 * @extends {BaseAPI}
 */
class ProductAttributesApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [pid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAttributesApi
     */
    deleteByProduct(pid, options) {
        return ProductAttributesApiFp(this.configuration).deleteByProduct(pid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [pid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAttributesApi
     */
    getAll(pid, options) {
        return ProductAttributesApiFp(this.configuration).getAll(pid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [pid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAttributesApi
     */
    getAllByProduct(pid, options) {
        return ProductAttributesApiFp(this.configuration).getAllByProduct(pid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [cid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAttributesApi
     */
    getByCategory(cid, options) {
        return ProductAttributesApiFp(this.configuration).getByCategory(cid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [pid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAttributesApi
     */
    getByProduct(pid, options) {
        return ProductAttributesApiFp(this.configuration).getByProduct(pid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {ProductAttributeToken} [ProductAttributeToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAttributesApi
     */
    insert(ProductAttributeToken, options) {
        return ProductAttributesApiFp(this.configuration).insert(ProductAttributeToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAttributesApi
     */
    remove(id, options) {
        return ProductAttributesApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {ProductAttributeToken} [ProductAttributeToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAttributesApi
     */
    update(ProductAttributeToken, options) {
        return ProductAttributesApiFp(this.configuration).update(ProductAttributeToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { ProductAttributesApi, ProductAttributesApiAxiosParamCreator, ProductAttributesApiFactory, ProductAttributesApiFp };
//# sourceMappingURL=product-attributes-api.js.map
